import React from 'react';
import './intro.scss';
import ch1photo from '../../assets/ch1.jpg';
import ch2photo from '../../assets/ch2.jpg';
import ch3photo from '../../assets/ch3.jpg';
import ch4photo from '../../assets/ch4.jpg';
import FloatingCubes from '../FloatingCubes/FloatingCubes';

function Intro() {
  return (
    <section className="intro">
      <FloatingCubes origin="intro" />
      <p>
        Even before computers were invented, the idea of the “thinking machine” persisted. In fact,
        in 1872, the Victorian novelist Samuel Butler’s book <span className="italic">Erewhon</span>{' '}
        imagined a world in which machines would employ human-like intelligence to tackle society’s
        most pressing problems.
      </p>

      <p>
        True <span className="italic">artificial intelligence</span>, however, has taken on
        different meanings and applications through the years. It gained momentum as a formal
        academic discipline in the 1950s, and while some strived to create an “electronic brain”
        capable of sentient thought, others sought to define the mechanical processes of higher
        logic so a machine could solve problems of unprecedented complexity.
      </p>
      <div className="intro__images">
        <div className="intro__images__row">
          <img src={ch1photo} alt="" />
          <img src={ch2photo} alt="" />
        </div>
        <div className="intro__images__row">
          <img src={ch3photo} alt="" />
          <img src={ch4photo} alt="" />
        </div>
      </div>
      <div className="intro__caption intro__caption-l">
        <span className="bold">Innovating with purpose-driven AI: </span> Micah Sheller, Intel Labs
        Senior Researcher (left); Jagadish Mahendran, Engineer/Developer (second from left);
        Rishikesh Amit Nayak, AI Creator (second from right); Lama Nachman, Intel Fellow (right).
      </div>
      <div className="intro__caption intro__caption-s">
        <span className="bold">Innovating with purpose-driven AI: </span>
        Micah Sheller, Intel Labs Senior Researcher (top left); Jagadish Mahendran,
        Engineer/Developer (top right); Rishikesh Amit Nayak, AI Creator (bottom left); Lama
        Nachman, Intel Fellow (bottom right).
      </div>
      <p>
        In the 2010s, the advent of Deep Learning across neural networks ushered in a technical
        breakthrough for AI development. The driving force behind this AI revolution has been the{' '}
        <span className="bluebold">
          democratization of the field through open-source collaborations
        </span>{' '}
        as well as processors and servers with the computing power to unleash AI’s potential—both
        areas Intel has pioneered.
      </p>
      <p>
        Here we take a closer look at four important areas where Intel’s AI technology is revealing
        its value to humankind and potentially revolutionizing industries.
      </p>
    </section>
  );
}

export default Intro;
